import appStoreAppOfTheYear2023White from "@assets/app_store_app_of_the_day_2023_black.webp"
import googleEditorsChoice2023White from "@assets/google_editors_choice_2023_black.webp"
import starIcon from "@assets/onboarding/Star.webp"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function CompanyPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="shrink-0 ">
        <h1 className="custom-heading text-center">
          {t("pages.onboarding.company.heading")}
        </h1>
      </div>

      <div className="flex grow flex-col justify-center space-y-8">
        <div className="flex items-center justify-center space-x-5">
          <img
            alt={t("pages.onboarding.company.appStoreAppOfTheYear2023")}
            className="w-36"
            src={appStoreAppOfTheYear2023White}
          />

          <img
            alt={t("pages.onboarding.company.googleEditorsChoice2023")}
            className="w-36"
            src={googleEditorsChoice2023White}
          />
        </div>

        <div className="space-y-4 text-center">
          <p className="heading text-lg">
            {t("pages.onboarding.company.andHas")}
          </p>

          <p className="custom-heading">
            {t("pages.onboarding.company.activeSubscribers")}
          </p>

          <div className="flex items-center justify-center gap-1">
            {Array.from({ length: 5 }).map((_, index) => (
              <img key={index} src={starIcon} alt="star" className="h-6 w-6" />
            ))}
          </div>
        </div>
      </div>

      <div className="shrink-0">
        <Form method="post">
          <input
            name={t("pages.onboarding.company.heading", {
              lng: "en",
            })}
            type="hidden"
            value={t("shared.continue", { lng: "en" })}
          />

          <Button title={t("shared.continue")} type="submit" />
        </Form>
      </div>
    </Layout>
  )
}
